import React from 'react';
import './StatsCard.css';

interface StatsCardProps {
  title: string;
  value: number | string;
  icon: string;
  color: string;
  subtitle?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  color,
  subtitle
}) => {
  return (
    <div className="stats-card" style={{ borderLeftColor: color }}>
      <div className="stats-icon" style={{ backgroundColor: `${color}20` }}>
        <span style={{ color }}>{icon}</span>
      </div>
      <div className="stats-content">
        <div className="stats-value" style={{ color }}>
          {value}
        </div>
        <div className="stats-title">
          {title}
        </div>
        {subtitle && (
          <div className="stats-subtitle">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;